export default __webpack_public_path__ + "static/media/thumbnail_3.b86a0069.webp";